// Join class names, dropping falsy values. Keeps the component files readable
// without pulling in clsx/tailwind-merge.
export function cn(...parts) {
  return parts.filter(Boolean).join(' ');
}
